export { default } from './IconContainerBlock';
export * from './IconContainerBlock';
